import { render } from "./AddProfilingFieldDialog.vue?vue&type=template&id=c9922faa&scoped=true"
import script from "./AddProfilingFieldDialog.vue?vue&type=script&lang=js"
export * from "./AddProfilingFieldDialog.vue?vue&type=script&lang=js"

import "./AddProfilingFieldDialog.vue?vue&type=style&index=0&id=c9922faa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9922faa"]])

export default __exports__